import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SelectedApexMech } from '@ortho-next/nextray-core';
import { ApproachImageEnum } from '../../services';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar to handle insertion point workflow.
*/
@Component({
	selector: 'insertion-point-workflow',
	templateUrl: './insertion-point-workflow.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class InsertionPointWorkflowComponent extends BaseComponent implements OnInit {

	helpImgAP: string | null = null;
	helpImgLT: string | null = null;
	isImgAPVisible = false;
	isImgLTVisible = false;


	ngOnInit(): void {
		this.helpImgAP = this._helpImgAP;
		this.hasLT && (this.helpImgLT = this._helpImgLT);
	}

	/**
	* Back to insertion approach selection.
	*/
	back(): void {
		this.canvasSrv.dispatch('cancelInsertionPoint');
		this.canvasSrv.dispatch('startSelectingApex');
	}

	/**
	* Close insertion point workflow.
	*/
	cancel(): void {
		this.canvasSrv.dispatch('cancelInsertionPoint');
		this.canvasSrv.dispatch('startSelectingApex');
		this.canvasSrv.dispatch('cancelSelectingApex');
	}

	/**
	* Confirm osteotomy site selection and place osteotomy line.
	*/
	confirm(): void {
		this.canvasSrv.dispatch('confirmInsertionPoint');
		this.canvasSrv.saveState();
	}

	private get _helpImgAP(): string | null {
		switch (this.selectedApex) {
			case SelectedApexMech.femurProximal:
				return this.isRight ? ApproachImageEnum.Right_AntegradeFemur_AP : ApproachImageEnum.Left_AntegradeFemur_AP;
			case SelectedApexMech.femurDistal:
				return this.isRight ? ApproachImageEnum.Right_RetrogradeFemur_AP : ApproachImageEnum.Left_RetrogradeFemur_AP;
			case SelectedApexMech.tibiaProximal:
				return this.isRight ? ApproachImageEnum.Right_AntegradeTibia_AP : ApproachImageEnum.Left_AntegradeTibia_AP;
			default:
				return null;
		}
	}

	private get _helpImgLT(): string | null {
		switch (this.selectedApex) {
			case SelectedApexMech.femurProximal:
				return this.isRight ? ApproachImageEnum.Right_AntegradeFemur_LT : ApproachImageEnum.Left_AntegradeFemur_LT;
			case SelectedApexMech.femurDistal:
				return this.isRight ? ApproachImageEnum.Right_RetrogradeFemur_LT : ApproachImageEnum.Left_RetrogradeFemur_LT;
			case SelectedApexMech.tibiaProximal:
				return this.isRight ? ApproachImageEnum.Right_AntegradeTibia_LT : ApproachImageEnum.Left_AntegradeTibia_LT;
			default:
				return null;
		}
	}

}
